import React from "react";
import ShoppingFeatures from "./ShoppingFeatures";
import Footer from "./Footer";
import Link from "next/link";

export default function About() {
  return (
    <>
      <nav className="my-5">
        <div className="container">
          <div className="row">
            <div className="col-12">
              {/* Breadcrumb */}
              <ol className="breadcrumb mb-0 font-size-xs text-gray-400">
                <li className="breadcrumb-item">
                  <Link href="/">
                    <a className="text-gray-400">Home</a>
                  </Link>
                </li>
                <li className="breadcrumb-item active">About Us</li>
              </ol>
            </div>
          </div>
        </div>
      </nav>

      <section>
        <div className="row justify-content-center py-5 bg-light bg-cover">
          <div
            className="col-12 col-md-8 col-lg-6 col-xl-5"
            style={{ minHeight: "10rem" }}
          >
            {/* Heading */}
            <h2 className="mb-0 text-center text-dark mx-5 mx-lg-0">
              "We believe everyone should have an equal opportunity to express
              their distinctive beauty."
            </h2>
          </div>
        </div>
      </section>

      <section className="py-5">
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-12 col-md-6">
              {/* Image */}
              <img
                src="/img/branding/about/about-23.jpg"
                alt="Chic Beauty Box"
                className="img-fluid w-50"
              />
              {/* Image */}
              <div className="text-right mt-n13 mt-lg-n15 mb-10 mb-md-0">
                <img
                  src="/img/branding/about/about-28.jpg"
                  alt="Chic Beauty Box"
                  className="img-fluid w-75"
                />
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-5">
              {/* Preheading */}
              <h6 className="heading-xxs mb-3 text-gray-400">Our story</h6>
              {/* Heading */}
              <h2 className="mb-7">Born out of passion</h2>
              {/* Text */}
              <p className="font-size-lg text-muted">
                A lifelong passion for beauty and equality inspired Mercy (our
                founder) to create Chic Beauty Box. Through her personal
                experiences and interactions as a social worker, Mercy quickly
                discovered that makeup, perfume, haircare and skincare products
                are surprisingly unaffordable for most people.
              </p>
              <p className="mb-0 font-size-lg text-muted">
                With this in mind, she sought to create a beauty subscription
                service that is affordable, and yet relatable by including
                brands that beginners and experts alike will both enjoy and find
                useful.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-12 bg-light">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              {/* Heading */}
              <h2 className="mb-10">Community Empowerment</h2>
            </div>
          </div>
          <div className="row justify-content-center mb-9 font-size-lg text-gray-500">
            <div className="col-12 col-md-5">
              <p>
                We're nothing without our community of #chicbabes. We curate
                boxes with the intent to inspire and express your own unique
                style.
              </p>
              <p className="mb-md-0">
                We believe every individual has at least one feature that makes
                them distinctly beautiful. It is our mission to help you
                discover and enhance it. That's why our box is completely
                customizable and personalized. We let you choose the products
                you want in your box. And where you don't have an option to
                choose, we use your beauty profile to select the perfect item -
                guaranteed.
              </p>
            </div>
            <div className="col-12 col-md-6 col-lg-5 font-size-lg text-gray-500">
              <p>
                Ultimately, we want to harbour a community where everyone feels
                safe and secure in themselves. We want to be more than just a
                subscription box. We want to be your beauty hub, your beauty
                magazine, your beauty forum. Want to talk beauty? Come to us.
                Want to express your beauty ideas? Look no further.
              </p>
              <p className="mb-0">
                In our community you'll never be overlooked or underrepresented.
                We welcome people of all races, cultures and backgrounds.
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-12 text-center">
              {/* Button */}
              <Link href="/#subscribe">
                <a className="btn btn-dark">
                  Get Your Box <i className="fe fe-arrow-right ml-2" />
                </a>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="py-12">
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-12 col-md-6 order-md-2 text-right">
              {/* Image */}
              <img
                src="/img/branding/about/about-29.jpg"
                alt="Chic Beauty Box"
                className="img-fluid w-50"
              />
              {/* Image */}
              <div className="text-left mt-n13 mt-lg-n15 mb-10 mb-md-0">
                <img
                  src="/img/branding/about/about-18.jpg"
                  alt="Chic Beauty Box"
                  className="img-fluid w-75"
                />
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-5 order-md-1">
              {/* Preheading */}
              <h6 className="heading-xxs mb-3 text-gray-400">Who we are</h6>
              {/* Heading */}
              <h2 className="mb-7">Not Just a Beauty Box</h2>
              {/* Text */}
              <p className="font-size-lg text-muted">
                We're committed to constantly innovate the beauty discovery
                experience. We want to introduce you to the most exciting brands
                from around the world.
              </p>
              <p className="mb-0 font-size-lg text-muted">
                Consider us your beauty scouts! Whether we are treating you to
                goodies in your box or discounts in our shop you'll always get
                the best deal right here.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container">
          <div className="row justify-content-center py-12 bg-primary bg-pattern">
            <div className="col-12 col-lg-10 col-xl-8">
              {/* Text */}
              <p className="font-size-h5 line-height-base text-center text-white">
                We are an all-inclusive brand with the sole mission: to empower
                the beauty community and provide an equal opportunity for all
                individuals to discover, afford and use high-quality beauty
                products. Our goal is to empower you to be your best confident
                self by providing you with USEFUL beauty products at
                exceptionally low prices.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="pt-12">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-md-6 col-lg-5">
              {/* Image */}
              <img
                className="img-fluid mb-7"
                src="/img/branding/about/about-30.jpg"
                alt="Chic Beauty Box"
              />
              {/* Image */}
              <img
                className="img-fluid mb-7 mb-md-0"
                src="/img/branding/about/about-12.jpg"
                alt="Chic Beauty Box"
              />
            </div>
            <div className="col-12 col-md-6 col-lg-5">
              {/* Image */}
              <img
                className="img-fluid mb-7 mt-md-12"
                src="/img/branding/about/about-31.jpg"
                alt="Chic Beauty Box"
              />
              {/* Image */}
              <img
                className="img-fluid mb-7 mb-md-0"
                src="/img/branding/about/about-10.jpg"
                alt="Chic Beauty Box"
              />
            </div>
          </div>
        </div>
      </section>

      <ShoppingFeatures />
      <Footer />
    </>
  );
}
